import React from 'react';
import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import ISave from 'icons/ISave';

export type SaveButtonProps = ButtonProps & {
  onlyIcon?: boolean;
};

const SaveButtonIcon = ({
  children = 'Save',
  onlyIcon = false,
  ...otherProps
}: SaveButtonProps) => {
  return (
    <Button
      icon={<ISave color="white" />}
      type="primary"
      style={{
        height: 33,
        width: onlyIcon ? 33 : 'auto',
        marginLeft: 8,
        marginRight: 5,
      }}
      {...otherProps}
    >
      {!onlyIcon ? children : null}
    </Button>
  );
};

export default SaveButtonIcon;
